import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  remove
} from '../redux/alarms'

export default function * requestRemoveAlarm (action) {
  const { id } = action.payload

  const optimisticAction = yield optimisticPut(remove(id))

  try {
    yield call(apiAction, 'RemoveAlarm', {
      alarmId: id
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
